import { createContext } from 'react'
import { useGetUserByEmail } from '@/operations/queries/getUserByEmail'
import { OrganisationList } from '@/operations/queries/getOrganisationList'
import { UserPermissionList, useGetUserPermissions } from '@/operations/queries/getUserPermissions'
import {
  Exact,
  Styra_Get_Organisation_ListQuery,
  Scalars,
  Ta_Permission_Type_Enum,
} from '@nemlia/hasura-gql/orgmgr/graphql'
import { ApolloClient } from '@apollo/client'
import { GetUserByEmailQuery } from '@nemlia/hasura-gql/developer/graphql'
import { NavItemsValueType, RolesType } from '../navItems'

type OrganisationsRefetch = (
  variables?: Partial<
    Exact<{
      [key: string]: never
    }>
  >
) => Promise<ApolloClient.QueryResult<Styra_Get_Organisation_ListQuery>>

type UserRefetch = (
  variables?: Partial<
    Exact<{
      email: Scalars['String']['input']
    }>
  >
) => Promise<ApolloClient.QueryResult<GetUserByEmailQuery>>

type PermissionsRefetch = ReturnType<typeof useGetUserPermissions>['refetch']

export interface GlobalContextProps {
  user: ReturnType<typeof useGetUserByEmail>['data']['ta_user'][0]
  currentOrganisation?: OrganisationList[0]
  organisations: OrganisationList
  setCurrentOrganisation: (id: string) => void
  language: string | null
  pageError: boolean
  pageLoading: boolean
  permissions: UserPermissionList
  hasFeature: (feature: Ta_Permission_Type_Enum, organisationId?: string) => boolean
  refetch: {
    user: UserRefetch
    organisations: OrganisationsRefetch
    permissions: PermissionsRefetch
  }
  navItems: NavItemsValueType[]
  role: RolesType
  isManager: boolean
  localeCompare: (a: string, b: string) => number
  localeCompareInsensitive: (a: string, b: string) => number
}

const GlobalContext = createContext<GlobalContextProps>(undefined)

export default GlobalContext
